// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import BackSaveController from "./back_save_controller"
import BackRestoreController from "./back_restore_controller"
application.register("hello", HelloController)
application.register("back-save", BackSaveController)
application.register("back-restore", BackRestoreController)
import SearchResetController from "./search_reset_controller"
application.register("search-reset", SearchResetController)

// Spot templates
import SpotTemplateOrientationController from "./spot_template_orientation_controller"
application.register("spot-template-orientation", SpotTemplateOrientationController)

// Spots
import SlotLengthController from "./slot_length_controller"
application.register("slot-length", SlotLengthController)

// The assistant — specs/32-spot-assistent.md
import SpotAssistantController from "./spot_assistant_controller"
import SpotAssistantFormController from "./spot_assistant_form_controller"
application.register("spot-assistant", SpotAssistantController)
application.register("spot-assistant-form", SpotAssistantFormController)

// QR code fields — specs/29-qr-code-felder.md
import QrFieldController from "./qr_field_controller"
application.register("qr-field", QrFieldController)

// Sites — specs/10-standorte.md
import SiteAddressController from "./site_address_controller"
application.register("site-address", SiteAddressController)

// Devices — specs/17-geraete.md
import DeviceKindController from "./device_kind_controller"
application.register("device-kind", DeviceKindController)
import DeviceResolutionController from "./device_resolution_controller"
application.register("device-resolution", DeviceResolutionController)
// The live view of a device — specs/38-fernzugriff.md
import RemoteViewController from "./remote_view_controller"
application.register("remote-view", RemoteViewController)

// Media library
import MediaPickerController from "./media_picker_controller"
import MediaDropController from "./media_drop_controller"
import DirectUploadController from "./direct_upload_controller"
import StreamCatchUpController from "./stream_catch_up_controller"
application.register("media-picker", MediaPickerController)
application.register("media-drop", MediaDropController)
application.register("direct-upload", DirectUploadController)
application.register("stream-catch-up", StreamCatchUpController)

// Mobile / Hotwire Native
import AppsRedirectController from "./apps_redirect_controller"
import TurboNativeSignOutController from "./turbo_native/sign_out_controller"
application.register("apps-redirect", AppsRedirectController)
application.register("turbo-native--sign-out", TurboNativeSignOutController)

// Third-party controllers
// data-controller="tom-select"   searchable / tag-style <select>
// data-controller="autocomplete" server-backed autocomplete input
import { Autocomplete } from "stimulus-autocomplete"
import TomSelectController from "stimulus-tom-select"
application.register("autocomplete", Autocomplete)
application.register("tom-select", TomSelectController)
